import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center display-2 my-16 font-weight-bold"
}
const _hoisted_2 = { class: "my-8" }
const _hoisted_3 = { class: "my-8" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = { class: "my-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    true
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "✍️ Essays"))
      : _createCommentVNode("", true),
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          height: "420px",
          cover: "",
          src: "/img/projects/essay-self-aware-software-artisan-technology-andromeda-mario-novak.webp"
        }),
        _createVNode(_component_v_alert, {
          class: "",
          variant: "tonal",
          "border-color": "purple"
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("h1", null, [
              _createElementVNode("a", { href: "https://medium.com/andromeda-technology/self-aware-software-artisan-the-manifesto-e9314290bced" }, " Self-Aware Software Artisan ")
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_chip, {
                outlined: "",
                class: "mr-2 mb-2"
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode("July 29th, 2021", -1)
                ])),
                _: 1,
                __: [0]
              })
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "my-8" }, " We are constructing a framework to power individual's continual evolution and meaningful contribution to humanity through Software Development. ", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "my-8" }, [
              _createElementVNode("ol", null, [
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/andromeda-technology/self-aware-software-artisan-the-manifesto-e9314290bced" }, "Intro"),
                  _createTextVNode("   | "),
                  _createElementVNode("strong", null, [
                    _createElementVNode("a", { href: "https://soundcloud.com/moltouni/self-aware-software-artisan-intro" }, "📣 AUDIO")
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/you-a-human-being-self-aware-software-artisan-f7c3641bf422" }, "You - A Human Being"),
                  _createTextVNode("   | "),
                  _createElementVNode("strong", null, [
                    _createElementVNode("a", { href: "https://soundcloud.com/moltouni/you-a-human-being-self-aware-software-artisan" }, "📣 AUDIO")
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/health-self-aware-software-artisan-66929c76b240" }, "Your Health"),
                  _createTextVNode("   | "),
                  _createElementVNode("strong", null, [
                    _createElementVNode("a", { href: "https://soundcloud.com/moltouni/your-health-self-aware-software-artisan" }, "📣 AUDIO")
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/educating-yourself-self-aware-software-artisan-25e74562c74d" }, "Question Everything"),
                  _createTextVNode("  | "),
                  _createElementVNode("strong", null, [
                    _createElementVNode("a", { href: "https://www.mixcloud.com/moltouni/question-everything-software-artisan-4/" }, "📣 AUDIO ")
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/deep-work-self-aware-software-artisan-1c2bdf0dc1dc" }, "Deep work")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/joining-existing-software-company-self-aware-software-artisan-38c21c9be12e" }, "Joining a Software Company")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/starting-a-software-company-self-aware-software-artisan-34bc562f19f9" }, "Starting a Software Company")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/team-self-aware-software-artisan-d765d4641c2e" }, "Team Artisanship")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/product-development-self-aware-software-artisan-9b828f601f3b" }, "Product Artisanship")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/code-self-aware-software-artisan-6c8712dfc45e" }, "Code Artisanship")
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("a", { href: "https://medium.com/@moltouni/finishing-up-self-aware-software-artisan-6143d5513395" }, "Finishing up")
                ])
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("strong", null, [
                _createVNode(_component_v_btn, {
                  large: "",
                  class: "mr-2 mb-2",
                  href: "https://medium.com/andromeda-technology/self-aware-software-artisan-the-manifesto-e9314290bced"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("h3", null, " Read on Medium ", -1)
                  ])),
                  _: 1,
                  __: [1]
                })
              ]),
              _createElementVNode("strong", null, [
                _createVNode(_component_v_btn, {
                  large: "",
                  class: "mr-2 mb-2",
                  href: "https://dev.to/moltouni/self-aware-software-artisan-4ehf"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createElementVNode("h3", null, " Read on Dev.to ", -1)
                  ])),
                  _: 1,
                  __: [2]
                })
              ])
            ])
          ]),
          _: 1,
          __: [3,4,5]
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_card, { class: "my-16" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          height: "420px",
          cover: "",
          src: "/img/projects/essay-progressive-web-development-technology-andromeda-mario-novak.webp"
        }),
        _createVNode(_component_v_alert, {
          class: "",
          variant: "tonal",
          "border-color": "purple"
        }, {
          default: _withCtx(() => [
            _cache[10] || (_cache[10] = _createElementVNode("h1", null, [
              _createElementVNode("a", { href: "https://medium.com/@moltouni/web-development-invest-your-time-wisely-d0c260b656d8" }, " Progressive Web Development - Invest your time wisely ")
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_chip, {
                outlined: "",
                class: "mr-2 mb-2"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("9 minute read", -1)
                ])),
                _: 1,
                __: [6]
              }),
              _createVNode(_component_v_chip, {
                outlined: "",
                class: "mr-2 mb-2"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("June 28th, 2020", -1)
                ])),
                _: 1,
                __: [7]
              })
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("p", { class: "my-8" }, [
              _createTextVNode(" Essay is geared towards beginners. "),
              _createElementVNode("br"),
              _createTextVNode(" The goal is to nullify Fear of Missing Out, with respect to all the technologies out there,"),
              _createElementVNode("br"),
              _createTextVNode(" and bring clarity and peace to the roadmap you will outline for yourself. ")
            ], -1)),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "my-8" }, [
              _createElementVNode("ol", null, [
                _createElementVNode("li", null, " Mastering the basics "),
                _createElementVNode("li", null, " Build as you learn "),
                _createElementVNode("li", null, " Plan and stick to your roadmap "),
                _createElementVNode("li", null, " Choosing your technology stack ")
              ])
            ], -1)),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "my-8" }, [
              _createElementVNode("h2", null, [
                _createTextVNode(" The Essay got selected and featured by the Medium Curators in the Programming topic, on July 2nd, 2020. "),
                _createElementVNode("br"),
                _createTextVNode(" Thank you for reading and sharing. ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("strong", null, [
                _createVNode(_component_v_btn, {
                  large: "",
                  class: "mr-2 mb-2",
                  href: "https://medium.com/@moltouni/web-development-invest-your-time-wisely-d0c260b656d8"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createElementVNode("h3", null, " Read on Medium ", -1)
                  ])),
                  _: 1,
                  __: [8]
                })
              ]),
              _createElementVNode("strong", null, [
                _createVNode(_component_v_btn, {
                  large: "",
                  class: "mr-2 mb-2",
                  href: "https://dev.to/moltouni/web-development-invest-your-time-wisely-4mh9"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createElementVNode("h3", null, " Read on Dev.to ", -1)
                  ])),
                  _: 1,
                  __: [9]
                })
              ])
            ])
          ]),
          _: 1,
          __: [10,11,12,13]
        })
      ]),
      _: 1
    })
  ]))
}